import React, { useState } from 'react';
import { trackWaitlistSignup, trackFormSubmission } from '../utils/analytics';

const WaitlistForm = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');

    try {
      const response = await fetch('https://connect.mailerlite.com/api/subscribers', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Bearer ${process.env.REACT_APP_MAILERLITE_API_KEY}`,
        },
        body: JSON.stringify({
          email: email,
          groups: ['159198976754583108'],
          status: 'active'
        })
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log('Subscriber created:', data);
      
      // Track successful signup
      trackWaitlistSignup(email);
      trackFormSubmission('Waitlist Form');
      
      setIsSubmitted(true);
      setEmail('');
      
    } catch (err) {
      console.error('Subscription error:', err);
      if (err.message.includes('API key')) {
        setError('Service temporarily unavailable. Please try again later.');
      } else if (err.message.includes('already exists')) {
        setError('This email is already on our waitlist!');
      } else {
        setError('Something went wrong. Please try again.');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isSubmitted) {
    return (
      <div className="text-center p-6 bg-green-50 rounded-lg border border-green-200">
        <div className="text-green-600 text-lg font-semibold mb-2">
          🎉 You're on the list!
        </div>
        <p className="text-green-700">
          Thank you for joining our waitlist. We'll notify you as soon as AkiMoon is ready!
        </p>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="w-full max-w-md mx-auto">
      <div className="flex flex-col sm:flex-row gap-3">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter your email address"
          required
          className="flex-1 px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent outline-none transition-all duration-200"
          disabled={isSubmitting}
        />
        <button
          type="submit"
          disabled={isSubmitting || !email}
          className="btn-primary disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none whitespace-nowrap"
        >
          {isSubmitting ? 'Joining...' : 'Join Waitlist'}
        </button>
      </div>
      {error && (
        <p className="text-red-600 text-sm mt-2 text-center">{error}</p>
      )}
      <p className="text-gray-500 text-xs mt-3 text-center">
        We respect your privacy. Unsubscribe at any time.
      </p>
    </form>
  );
};

export default WaitlistForm; 